import { VolumeUp } from "@mui/icons-material";
import { Alert, Snackbar } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";

export function NotificationSoundCheck() {
  const [audioUnlocked, setAudioUnlocked] = useState(false);
  const mounted = useRef(true);

  const unlock = useCallback(() => {
    if (mounted.current) setAudioUnlocked(true);
  }, []);

  useEffect(() => {
    document.body.addEventListener("click", unlock);
    return () => {
      mounted.current = false;
      document.body.removeEventListener("click", unlock);
    };
  }, [unlock]);

  useEffect(() => {
    if (audioUnlocked) {
      document.body.removeEventListener("click", unlock);
    }
  }, [audioUnlocked, unlock]);

  if (audioUnlocked) return null;

  return (
    <Snackbar open anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
      <Alert
        severity="info"
        icon={<VolumeUp fontSize="small" />}
        sx={{ alignItems: "center" }}
      >
        Tap anywhere to enable sound alerts
      </Alert>
    </Snackbar>
  );
}
